import { radiometerNames } from '@features/components/ClinicalData/constants';
import { RadiometerFirstSection, RadiometerType } from '@/api/apis/case';
import { ClinicalGridItem } from './ClinicalGridItem';

type RadiometerContentGridProps = {
  stats: RadiometerFirstSection;
};

export const RadiometerContentGrid = ({ stats }: RadiometerContentGridProps) => {
  return (
    <div className="grid grid-cols-4 grid-rows-2 gap-y-3 pt-2 px-2">
      <ClinicalGridItem name="Type" value={radiometerNames[stats.type as RadiometerType] || '-'} />
      <ClinicalGridItem name="PCO2" unit="mmHg" value={stats.pcO2} />
      <ClinicalGridItem name="PO2" unit="mmHg" value={stats.paO2} />
      <ClinicalGridItem name="TCO2" unit="mmol/L" value={stats.tcO2} />
      <ClinicalGridItem name="HC03" unit="mmol/L" value={stats.hcO3} />
      <ClinicalGridItem name="BEecf" unit="mmol/L" value={stats.bEecf} />
      <ClinicalGridItem name="SO2" unit="%" value={stats.sO2} />
      <ClinicalGridItem name="pH" value={stats.pH} />
    </div>
  );
};
